import { FC, useContext } from "react";
import ContextStore from "../../../../hooks/ContextStore";
import { t } from "../../i18n/ar";

// Warehouse availability chip — NO numbers (user 2026-09-14): the worker only
// needs to know whether the warehouse holds what the open orders need.
//   null/undefined → gray  "stock not recorded"
//   0              → red   "warehouse empty — ask Casablanca to send"   (pulses)
//   < needed       → amber "not enough — ask Casablanca"
//   ≥ needed       → green "available in the warehouse"
// An ADMIN also sees the exact count (user 2026-10-26: "only me as administrator sees how many; the fulfilment guy only
// needs to see it is in the warehouse").
export const StockChip: FC<{ stock?: number | null; needed?: number; big?: boolean }> = ({ stock, needed, big }) => {
    const { contextStore } = useContext(ContextStore);
    const admin = contextStore?.user?.type === "admin";
    const size = big ? "text-lg" : "text-base";
    const count = admin && stock != null && stock > 0 ? <span className="ltr rounded bg-white/70 px-1.5 font-black text-slate-900">{stock}</span> : null;
    if (stock == null) {
        return (
            <span className={`inline-flex items-center gap-1 rounded-lg bg-slate-100 px-2 py-0.5 ${size} font-bold text-slate-400`}>
                🏬 {t.stockUnknown}
            </span>
        );
    }
    if (stock <= 0) {
        return (
            <span className={`inline-flex animate-pulse items-center gap-1 rounded-lg bg-red-600 px-2.5 py-1 ${size} font-black text-white`}>
                🏬 🚫 {t.stockEmpty}
            </span>
        );
    }
    if (needed != null && stock < needed) {
        return (
            <span className={`inline-flex items-center gap-1 rounded-lg bg-amber-400 px-2.5 py-1 ${size} font-black text-slate-900`}>
                🏬 ⚠️ {t.stockLow} {count}
            </span>
        );
    }
    return (
        <span className={`inline-flex items-center gap-1 rounded-lg bg-emerald-100 px-2 py-0.5 ${size} font-bold text-emerald-700`}>
            🏬 ✓ {t.stockAvailable} {count}
        </span>
    );
};
